import * as constant from '../constants/string';
import { ChangeRequestControllerService } from '../../services';

export const getValueAuthority = (label) => {
    const result = constant.AUTHORITY.filter((element) => label === element.label);
    return result[0].value;
};

export const getValueOrganization = (label) => {
    const result = constant.ORGANIZATION.filter((element) => label === element.label);
    return result[0].value;
};

export const addSelectedData = (apiResponse, setSelectData) => {
    if (apiResponse) {
        const displayData = apiResponse.data;
        setSelectData((prevState) => {
            const newData = [
                ...prevState.filter((item) => !displayData.some((newItem) => newItem.id === item.id)),
                ...displayData.filter((newItem) => newItem.selected),
            ];

            return newData;
        });
    }
};

export const editSelectedData = (apiResponse, setSelectData) => {
    if (apiResponse) {
        const displayData = apiResponse.data;
        setSelectData((prevState) => {
            const newDataMap = new Map(prevState.map((item) => [item.id, item])); // 既存データをMapに変換

            displayData.forEach((newItem) => {
                newDataMap.set(newItem.id, newItem); // 既存なら更新、新規なら追加
            });

            return Array.from(newDataMap.values()); // Mapを配列に戻す
        });
    }
};

export const addConfirmedData = (apiResponse, setSelectData) => {
    if (apiResponse) {
        const displayData = apiResponse.data;
        setSelectData((prevState) => {
            const newData = [
                ...prevState.filter((item) => !displayData.some((newItem) => newItem.id === item.id)),
                ...displayData.filter((newItem) => newItem.remand || newItem.confirmed),
            ];
            return newData;
        });
    }
};

export const updateSelectedData = (changeRequestType, ids, setSelectedData) => {
    ChangeRequestControllerService.getChangeRequestsByIds(changeRequestType, ids)
        .then((response) => {
            editSelectedData(response, setSelectedData);
        })
        .catch((error) => {});
};
